import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { QueryClient, QueryClientProvider } from "react-query";

import Unauthenticated from './Unauthenticated';
import Root from './components/Root';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

const App = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <QueryClientProvider client={queryClient}>
          <Root/>
        </QueryClientProvider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Unauthenticated/>
      </UnauthenticatedTemplate>
    </>
  );
}

export default App;
